import { useUserSSOInfo } from '@/hooks/useAuth/useAuth';
import { useTenantList } from '@/hooks/useSwr';

export const useSAMLEmptyState = () => {
  const { isSSOLogin } = useUserSSOInfo();
  const tenants = useTenantList({ revalidateOnFocus: false });

  // Disable interactions for SAML users with no tenants (empty state)
  const isSAMLEmptyState =
    isSSOLogin && (!tenants.data || tenants.data.length === 0);

  return {
    isSAMLEmptyState,
    isSSOLogin,
    tenants: tenants.data,
  };
};
